
import React from 'react'
import firebaseApp from '../../firebase';
import './styles/FileUpload.scss'

const rootStyle = {
  'display': 'inline-block'
}

class DocumentUpload extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      'progress': null,
      'done': false
    }
    this.uploadDocument = this.uploadDocument.bind(this)
    this.onProgress = this.onProgress.bind(this)
    this.complete = this.complete.bind(this)
    this.error = this.error.bind(this)
  }

  complete(fileName){
    this.setState({
      'progress': null
    })
    let doc = {name: fileName}
    this.storageRef.getDownloadURL()
      .then(url => {
        doc.url = url;
        this.props.callback(doc)
      })
  }
  error(err){
    console.log(err);
  }

  onProgress(snapshot){
    let percentage = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
    this.setState({
      'progress': percentage
    })
  }

  uploadDocument(file){
    const fileName = this.props.name || file.name.split('.')[0] + '-' + (+new Date());
    const ext = file.name.split('.').slice(-1)[0].toLowerCase()
    const path = this.props.path

    this.storageRef = firebaseApp.storage().ref(`${path}${fileName}.${ext}`);

    // upload the doc
    const task = this.storageRef.put(file)
    task.on('state_changed', this.onProgress, this.error, () => this.complete(fileName))
  }

  render(){
    const { progress } = this.state;
    return (<div className="uploader" style={rootStyle}>

      { progress ? <div className="progress">
        <div className="md-caption">Uploading... </div>
        <div className="bar" style={{
            width: `${progress}%`
          }
        }>{progress}%</div>
        </div>
      : <div className="upload-button">
      <svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"/>
        <path d="M0 0h24v24H0z" fill="none"/>
      </svg>

      <input  accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,
text/plain, application/pdf, image/*" type="file" onChange={(e) => {
          this.uploadDocument(e.target.files[0], 'documents/')
        }
      } />
      </div>
    }
    </div>)
  }

}

DocumentUpload.defaultProps = {
  'name': null,
  'path': 'documents/',
  'callback': () =>{}
}

export default DocumentUpload;



// WEBPACK FOOTER //
// ./src/components/ui/DocumentUpload.jsx